/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Media_EmptyInputs */

const cs_draft_media_empty = /** @type {(inputs: Draft_Media_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tento inzerát nemá připravené fotky k umístění do slotů.`)
};

const en_draft_media_empty = /** @type {(inputs: Draft_Media_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This listing has no ready photos to place in slots.`)
};

/**
* | output |
* | --- |
* | "This listing has no ready photos to place in slots." |
*
* @param {Draft_Media_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_media_empty = /** @type {((inputs?: Draft_Media_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Media_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_media_empty(inputs)
	return cs_draft_media_empty(inputs)
});